import React from 'react'
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa'
import Button from './Button'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMessage: '' }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || '页面发生异常' }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Portal ErrorBoundary caught error:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
          <div className="max-w-lg w-full bg-white border border-red-100 rounded-xl p-8 shadow-sm text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 text-red-600 flex items-center justify-center">
              <FaExclamationTriangle className="w-8 h-8" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">页面加载失败</h2>
            <p className="text-gray-600 mb-6">{this.state.errorMessage || '请稍后重试，或联系管理员处理。'}</p>
            <Button icon={<FaRedo />} onClick={this.handleReload}>刷新页面</Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
